// src/pages/About.jsx
import React, { useState, useEffect } from "react";
import "./About.css";
import aboutImg from "../assets/about-img.jpg"; // left column image
// sector images
import renewableImg from "../assets/sectors_Renewable energy.jpg";
import infraImg from "../assets/Sectors_Infrastructure_Development.webp";
import petroImg from "../assets/sectors_petrochemicals.jpg";
import steelImg from "../assets/sectors_erection steel.jpeg";
import oilgasImg from "../assets/sectors_oil&gas.webp";
import manufImg from "../assets/sectors_manufacturing.webp";
import powerImg from "../assets/sectors_powerplants.jpg";

// MD photo

const About = () => {
  const [openIndex, setOpenIndex] = useState(null);

// Set Browser Tab Title for About Page
useEffect(() => {
  document.title = "About | Qnexa Services — Engineering & Inspection Specialists";
}, []);

const toggle = (i) => setOpenIndex(openIndex === i ? null : i);


  const sections = [
    {
      title: "A Customer-Focused Quality",
      content:
        "We specialize in providing experienced Quality Inspectors, skilled technical manpower, and end-to-end quality reporting support. Our services include the preparation of detailed quality reports,timely report reviews, and continuous follow-up to ensure transparency, accuracy, and completeclient satisfaction.",
    },
    {
      title: "Honesty &amp; Accountability",
      content:
        "We provide a highly qualified and certified pool of OIL- and GAS-approved inspectors with extensiveindustry experience. Our teams operate with integrity and accountability, ensuring strict adherenceto quality, safety, and compliance standards across all projects.",
    },
    {
      title: "Performance Optimization",
      content:
        "Leveraging digital platforms, we ensure 24/7 accessibility, streamlined inspection workflows, real-time reporting, and enhanced communication. This enables efficient project management, fasterdecision-making, and consistently superior outcomes for our clients.",
    },
    {
      title: "Reliable &amp; Professional Service",
      content:
        "Every member of Qnexa Services is dedicated to maintaining the highest standards of professionalism, integrity, and technical expertise. We consistently strive for excellence, ensuring our clients receive superior quality services, timely support, and reliable solutions tailored to their needs.",
    },
    {
      title: "Future-Ready &amp; Flexible Solutions",
      content:
        "We embrace innovation and adaptability to meet the evolving needs of our clients. By leveraging advanced technologies and flexible processes, Qnexa Services delivers solutions that are efficient, scalable, and prepared for the challenges of tomorrow.",
    },
    {
      title: "Partner with Us",
      content:
        "Whether you need technical inspections, verifications, or conformity assessment services, Qnexa Services is your trusted partner for success. Collaborate with us to enhance quality, ensure compliance, and take your business to new heights.",
    },
  ];

  const sectors = [
  { title: "Renewable Energy", img: renewableImg },
  { title: "Infrastructure Development", img: infraImg },
  { title: "Petrochemicals", img: petroImg },
  { title: "Steel Structure Erection", img: steelImg },
  { title: "Oil & Gas", img: oilgasImg },
  { title: "Manufacturing", img: manufImg },
  { title: "Power Plants", img: powerImg },
];


  return (
    <div className="about-page">
      <div className="about-banner">
        <h1>About</h1>
      </div>

      <div className="about-body">
        {/* Intro */}
        <div className="about-intro">
          <p>
            Welcome to <strong>Qnexa Services</strong>, Established in 2015, Qnexa Services is a professional Engineering and Inspection Solutions provider
led by a team of seasoned engineering entrepreneurs. We serve a wide range of sectors, including
Oil &amp; Gas, Petrochemicals, Power, Renewable Energy, Water Treatment, Infrastructure, Industrial
Projects, Pipeline Construction, and Pressure Vessels Fabrication.
          </p>

          <p>
            We deliver reliable, cost-effective, and high-quality consultancy, project supervision, and
inspection services to ensure timely execution, cost optimization, and full compliance with
international quality, welding, and safety standards.
          </p>

          <p>
  <strong>Our expertise includes providing certified and experienced inspectors across India, covering:</strong><br />
  • Pipeline Inspection (Cross-country &amp; Plant Piping)<br />
  • Pressure Vessels, Storage Tanks &amp; Boilers<br />
  • Structural Steel, Mechanical Equipment, Rotating &amp; Static Machinery<br />
  • Electrical, E&amp;I, and Civil Inspection Services<br /><br />

  <strong>Our inspector pool includes personnel certified in:</strong><br />
  • CSWIP 3.1 &amp; CSWIP 3.2<br />
  • BGAS Grade 1 &amp; Grade 2<br />
  • API Certifications (API 510, 570, 653, 936, etc.)<br />
  • ASNT/ISNT NDT Level II &amp; Level III<br />
  • Painting, Welding, Coating &amp; QA/QC Specialisations<br /><br />

  With a strong pan-India presence, Qnexa Services ensures the deployment of highly skilled,
  qualified, and certified inspectors to support multiple project sites and client requirements.
</p>

        </div>

        {/* Left image + Right accordion */}
        <div className="about-two-col">
          <div className="left-image">
            <img src={aboutImg} alt="Qnexa" />
          </div>

          <div className="right-accordion">
            {sections.map((s, idx) => (
              <div key={idx} className="accordion-box">
                <div
                  className="accordion-head"
                  role="button"
                  onClick={() => toggle(idx)}
                  onKeyDown={() => toggle(idx)}
                  tabIndex={0}
                >
                  <span className={`symbol ${openIndex === idx ? "open" : ""}`}>
                    {openIndex === idx ? "−" : "+"}
                  </span>
                  <div className="heading-and-line">
                    <h3 className="acc-title">{s.title}</h3>
                    <div className="acc-underline" />
                  </div>
                </div>

                <div
                  className={`accordion-body ${openIndex === idx ? "show" : ""}`}
                  aria-hidden={openIndex !== idx}
                >
                  <p>{s.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Straight bottom-statement line under images and content */}
        <div className="bottom-statement-line">
          We take immense pride in our expanding portfolio of services that cater to multinational
          corporations, global and national companies, as well as medium and small-scale industries
          across diverse sectors.
        </div>

        {/* Sectors Section */}
        <div className="sectors-wrapper">
          <div className="sectors-intro">
            <div className="small-title">Diverse Horizons</div>
            <h2 className="sectors-main-title">SECTORS</h2>
          </div>

          <div className="sectors-grid">
            {sectors.map((item, i) => (
              <div key={i} className="sector-card">
                <div className="sector-image">
                  <img src={item.img} alt={item.title} />
                </div>
                <div className="sector-caption">{item.title}</div>
              </div>
            ))}
          </div>
        </div>

        

        {/* QUALITY POLICY section */}
        <section className="quality-policy">
          <div className="quality-inner">
            <div className="quality-left">
              <h2>QUALITY POLICY</h2>

              <p>
                At <strong>Qnexa Services</strong>, our primary emphasis is on continuous improvement, backed
                by disciplined inspection methodologies and a commitment to meet and exceed industry benchmarks.
                Impartiality, integrity and technical competence are central to every service we deliver.
              </p>

              <p>
                Customer satisfaction is our cornerstone. We aim to deliver reliable, timely and compliant inspection
                and consultancy services that help our clients manage project risk, optimize costs, and achieve
                regulatory compliance across sectors.
              </p>

              <p>
                We promote ethical practices, invest in staff competency, and embrace digital tools to ensure consistent
                quality. Environmental stewardship & safety remain core considerations in our operations.
              </p>

              
            </div>

            <div className="quality-right">
              <div className="quality-card">
                <h4>Quality Objective</h4>

                <ul className="quality-list">
                  <li>Deliver technically precise, reliable and value-added inspection services.</li>
                  <li>Enhance client satisfaction by consistently meeting quality requirements.</li>
                  <li>Ensure impartiality and objectivity across all services and interactions.</li>
                  <li>Commit to continual improvement of processes to exceed industry benchmarks.</li>
                  <li>Continuously develop personnel competence and innovation in our services.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* ========== HSE POLICY SECTION ========== */}
<section className="hse-section" aria-label="HSE Policy">
  <div className="hse-inner">
    <div className="hse-left">
      <h2>HSE POLICY</h2>

      <p>
        At <strong>Qnexa Services</strong>, we are dedicated to fostering a robust culture of Health,
        Safety, and Environment (HSE) across all aspects of our business. We aim to provide a safe
        workplace where employees, visitors and stakeholders take responsibility for their own safety
        while contributing to a sustainable environment.
      </p>

      <p>
        Our commitment to HSE applies across our offices and project sites. Through continuous
        improvement, training and adherence to best practices, we ensure a compliant, safe, and
        environmentally conscious work environment. Safety is a shared priority, supporting
        sustainable growth and operational excellence.
      </p>

     
    </div>

    <div className="hse-right">
      <div className="hse-card">
        <h4>Key Objective</h4>
        <ul className="hse-list">
          <li>Build a strong HSE system at corporate level and make sure it's part of daily work.</li>
          <li>Use resources wisely, reduce waste and adopt eco-friendly practices.</li>
          <li>Identify and remove hazards, involving employees to reduce health & safety risks.</li>
          <li>Continuously train employees and stakeholders on HSE policies and safe practices.</li>
          <li>Encourage personal responsibility for HSE in communications and meetings.</li>
          <li>Follow all relevant HSE laws and regularly update our policies to stay compliant.</li>
          <li>Regularly monitor and review our HSE performance.</li>
        </ul>
      </div>
    </div>
  </div>
</section>
{/* ========== CORE VALUES SECTION ========== */}
<section className="core-values-section">
  <div className="core-values-inner">

    <div className="core-title-block">
      <div className="core-small-title">Driving Principles</div>
      <h2 className="core-main-title">CORE VALUES</h2>

      <p className="core-desc">
        At Qnexa Services, our team of competent engineers ensures that all inspections, 
        installations, and technical services meet required regulatory and performance standards. 
        Our professionals carry extensive hands-on experience across multiple industries, enabling 
        them to navigate complex engineering challenges with precision and integrity.
      </p>
    </div>

    <div className="core-grid">

      {/* 1 */}
      <div className="core-card">
        <div className="core-icon">👥</div>
        <h3>Technical Expertise</h3>
        <p>
          Delivering top-quality technical services and performance standards through skilled professionals.
        </p>
      </div>

      {/* 2 */}
      <div className="core-card">
        <div className="core-icon">✨</div>
        <h3>Commitment to Excellence</h3>
        <p>
          Consistently achieving exceptional outcomes in quality, performance, and client satisfaction.
        </p>
      </div>

      {/* 3 */}
      <div className="core-card">
        <div className="core-icon">🌿</div>
        <h3>Sustainability</h3>
        <p>
          Promoting continuous learning and adopting environmentally conscious quality standards.
        </p>
      </div>

      {/* 4 */}
      <div className="core-card">
        <div className="core-icon">🛡</div>
        <h3>Integrity</h3>
        <p>
          Upholding honesty, transparency, and strong ethical conduct throughout all operations.
        </p>
      </div>

      {/* 5 */}
      <div className="core-card">
        <div className="core-icon">⚙️</div>
        <h3>Continuous Improvement</h3>
        <p>
          Fostering a culture of ongoing learning, innovation, and process enhancement.
        </p>
      </div>

      {/* 6 */}
      <div className="core-card">
        <div className="core-icon">🌍</div>
        <h3>Responsible Stewardship</h3>
        <p>
          Managing resources wisely while reducing environmental and operational risks.
        </p>
      </div>

      {/* 7 — centered last card */}
      <div className="core-card core-last">
        <div className="core-icon">🤝</div>
        <h3>Social Responsibility</h3>
        <p>
          Contributing positively to society and uplifting communities through responsible actions.
        </p>
      </div>

    </div>

  </div>
</section>


      </div>
    </div>
  );
};

export default About;
